export default {
    step(state) {
        return state.step;
    },
    preview(state) {
        return state.preview;
    },
    preview_date(state) {
        return state.preview_date;
    },
    header_count(state) {
        return state.header_count;
    },
    tile_count(state) {
        return state.tile_count;
    },
    header_url(state) {
        return state.header_url;
    },
    header_file(state) {
        return state.header_file;
    },
    tile_images(state) {
        return state.tile_images;
    },
    email(state) {
        return state.email;
    }
};
